<div class="row row-padding-bottom client-plans">
  <div class="medium-6 strategy-type">
    Your investment in {{orgName}}:
  </div>
  <div class="medium-6">
    <ng-template [ngIf]="!freezPlan && !userReadOnly">
      <div class="float-right pointer" style="margin: 0 10px;color: #1570EF;display: inline-flex;" (click)="addNewFeeLine()">
        <i class="material-icons">add</i><span style="position: relative;top: 2px;">Add Fees</span>
      </div>
    </ng-template>
  </div>
  <div class="medium-12">
    <div class="row no-hover client-todos tax-strategy client-plans badge-tables" style="overflow-y: auto; padding: 0;">
      <div class="medium-12 large-12 tpiq-paginated-table invoices scenarios">
        <table style="margin-top: 0 !important;">
          <thead>
          <tr>
            <th *ngFor="let column of columns">
              <span>{{column.title}}</span>
            </th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <ng-template [ngIf]="feesTableData && feesTableData.length == 0">
            <tr class="text-center">
              <td [attr.colspan]="columns.length">
                <div class="callout text-center">
                  <p>No Results Found.</p>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template [ngIf]="feesTableData && feesTableData.length > 0">
            <tr *ngFor="let row of feesTableData;let i=index">
              <td *ngFor="let col of columns;let idx=index">
                <ng-template [ngIf]="col.name == 'frequency'">
                  <!-- <div class="pointer table-col" *ngIf="row['type'] == 'One Time'"></div> -->
                  <div class="pointer table-col">{{row[col.name]}}</div>
                </ng-template>
                <div class="pointer table-col" *ngIf="col.name != 'frequency'">{{row[col.name]}}</div>
              </td>
              <td>
                <div class='badge-tooltip'>
                  <a class='action' data-action='ignition' *ngIf="row.platform" (click)="openIgnition(row)"><img style="width: 15px;margin-right: 15px;" src="../../../images/ignition.png"/></a>
                  <ng-template [ngIf]="!freezPlan && !userReadOnly">
                    <a class='action' data-action='edit' (click)="editFee(row, i)"><i class="material-icons strategy-action-icon">mode_edit</i></a>
                    <a class='action' data-action='delete'><span class='todo-del' (click)="deleteFeeLine(i)"><i class="material-icons delete">delete</i></span></a>
                  </ng-template>
                </div>
              </td>
            </tr>
          </ng-template>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="medium-12" style="font-size: 12px;">
    <span style="color: #f1645a; font-size: 14px;">*</span>
    <div><span style="color: #0AA8E2; font-weight: bold;">One Time:</span> One time fees may include an onboarding fee, a tax planning fee, third party vendor costs, attorney fees, or reimbursements.</div>
    <div><span style="color: #0AA8E2; font-weight: bold;">Prepaid:</span> Add last year's compliance fees paid, whether to your firm or to a prior accounting firm. This will help in showing the true value of your new strategies. This will show up as a negative amount on your ROI.</div>
  </div>
</div>

<div *ngIf="reveal['addNewFeeLine']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['addNewFeeLine']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 75%;" [ngClass]="{'tpiq-reveal': reveal['addNewFeeLine']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left"> {{ editMode ? 'Edit ' + (this.costLine?.type + ' Fee') : 'Add Fee' }}</span>
      <span class="float-right pointer" (click)="hideReveal('addNewFeeLine')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;height: calc(100vh - 125px);overflow-y: scroll;">
      <app-add-new-fee #roiFeeInfo [plan]="clientTaxPlan" [editMode]="editMode" [feeLine]="costLine" [costLines]="costLines"
                               (onAddOrEditFee)="saveFee($event)"></app-add-new-fee>
    </div>
  </div>
</div>

<div *ngIf="reveal['implementationFee']">
  <div class="reveal-overlay" [ngClass]="{'tpiq-reveal': reveal['implementationFee']}">
  </div>
  <div class="reveal tax-strategy-reveal" style="padding: 0; border: none; width: 60%;" [ngClass]="{'tpiq-reveal': reveal['implementationFee']}">
    <div style="height: 50px; padding: 15px; color: #333333;">
      <span class="float-left">Suggested Implementation Fee</span>
      <span class="float-right pointer" (click)="hideReveal('implementationFee')">X</span>
    </div>
    <div style="padding: 0 15px;">
      <hr style="margin: 0;"/>
    </div>
    <div class="body" style="padding: 15px;height: 60vh;overflow-y: scroll;">
      <app-suggest-fee [clientTaxPlan]="clientTaxPlan"></app-suggest-fee>
    </div>
  </div>
</div>
